/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Draw_ProviderInputs */

const en_endpoint_draw_provider = /** @type {(inputs: Endpoint_Draw_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const zh_hans1_endpoint_draw_provider = /** @type {(inputs: Endpoint_Draw_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务商`)
};

const pt_br2_endpoint_draw_provider = /** @type {(inputs: Endpoint_Draw_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedor`)
};

const es_endpoint_draw_provider = /** @type {(inputs: Endpoint_Draw_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor`)
};

const fr_endpoint_draw_provider = /** @type {(inputs: Endpoint_Draw_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseur`)
};

const de_endpoint_draw_provider = /** @type {(inputs: Endpoint_Draw_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter`)
};

const ru_endpoint_draw_provider = /** @type {(inputs: Endpoint_Draw_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик`)
};

const it_endpoint_draw_provider = /** @type {(inputs: Endpoint_Draw_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Endpoint_Draw_ProviderInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_draw_provider = /** @type {((inputs?: Endpoint_Draw_ProviderInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Draw_ProviderInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_draw_provider(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_draw_provider(inputs)
	if (locale === "es") return es_endpoint_draw_provider(inputs)
	if (locale === "fr") return fr_endpoint_draw_provider(inputs)
	if (locale === "de") return de_endpoint_draw_provider(inputs)
	if (locale === "ru") return ru_endpoint_draw_provider(inputs)
	if (locale === "it") return it_endpoint_draw_provider(inputs)
	return en_endpoint_draw_provider(inputs)
});